module.exports = __webpack_public_path__ + "img/kitchen-display.49db5910.webp";